import { type MouseEvent, useState } from 'react';

const useMenu = () => {
  const [anchorElem, setAnchorElem] = useState<Element | null>(null);

  const openMenu = (event: MouseEvent<any>) => {
    setAnchorElem(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorElem(null);
  };

  return {
    anchorElem,
    openMenu,
    closeMenu
  };
};

export default useMenu;
